import React, { FC } from 'react'
import styles from 'styles/components/label.module.scss'

type Props = {
  endIcon?: string
  label: string
  onClick?: () => void
}

const CautionFixedLabel: FC<Props> = React.memo((props) => {
  const { endIcon, label, onClick } = props

  return (
    <button className={styles.caution} disabled={!onClick} onClick={onClick}>
      <span>{label}</span>
      {endIcon && <img className={styles.caution__icon} src={endIcon} alt="" />}
    </button>
  )
})

export default CautionFixedLabel
